import { mapValues } from "lodash-es"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat.js"

dayjs.extend(customParseFormat)

const mergeSettings = (itemSettings, categorySettings) => {
  const itemList = itemSettings || []
  const categoryList = categorySettings || []

  if (!itemList.length && !categoryList.length) return null

  const itemKeys = new Set(itemList.map((setting) => setting.key))

  const categoryOnly = categoryList.filter(
    (setting) => !itemKeys.has(setting.key)
  )

  return [...itemList, ...categoryOnly]
}

export const assembleMenuItems = (item, category) => {
  const foodItem = {
    ...item,
    settings: mergeSettings(item.settings, category.settings),
    category_key: category.key,
    hasImage: item.images || category.images || false,
    zusatz: Array.from(
      new Set([...(item.zusatz || []), ...(category.zusatz || [])])
    ),
    pick_up_discount:
      item.pick_up_discount || category.pick_up_discount || null,
    tax: item.tax || category.tax || null,
    mainTax: item.mainTax || category.mainTax || null,
    info: category.info
      ? `${category.info} ${item.info || ""}`
      : item.info || "",
    info_i18n: category.info_i18n
      ? Object.fromEntries(
          Object.entries(category.info_i18n).map(([lang, text]) => [
            lang,
            `${text} ${item.info_i18n?.[lang] || ""}`,
          ])
        )
      : item.info_i18n || null,
    details: category.details
      ? `${category.details} ${item.details || ""}`
      : item.details || "",
    details_i18n: category.details_i18n
      ? Object.fromEntries(
          Object.entries(category.details_i18n).map(([lang, text]) => [
            lang,
            `${text} ${item.details_i18n?.[lang] || ""}`,
          ])
        )
      : item.details_i18n || null,
  }

  return foodItem
}

export const calculateChoicesCosts = (choices, settings) => {
  if (!choices) return 0
  if (!settings) return 0

  return Object.entries(choices).reduce((acc, [key, value]) => {
    const setting = settings.find((set) => set.key === key)
    if (!setting || !setting.options.find((opt) => opt.preis)) return acc
    switch (setting?.type) {
      case "checkbox":
        return (
          acc +
          value.reduce((sum, val) => {
            const option = setting.options.find((opt) => opt.value === val)
            return sum + (option ? option.preis : 0)
          }, 0)
        )
      case "radio":
        const option = setting.options.find((opt) => opt.value === value)
        return acc + (option ? option.preis : 0)

      default:
        return acc
    }
  }, 0)
}

export const categoryIcons = [
  "bao.png",
  "bao2.png",
  "beef.png",
  "breakfast.png",
  "bubble.png",
  "bubble2.png",
  "bubble3.png",
  "bubble4.png",
  "bubble5.png",
  "burgermenu.png",
  "burgermenu2.png",
  "burger.png",
  "burger2.png",
  "burger3.png",
  "chicken.png",
  "chicken2.png",
  "chili.png",
  "cocktail.png",
  "cocktail2.png",
  "cocktail3.png",
  "cocktail4.png",
  "cocktail5.png",
  "cocktail6.png",
  "dessert.png",
  "drinks.png",
  "duck.png",
  "extra.png",
  "fish.png",
  "fish2.png",
  "friedchicken.png",
  "friedchicken2.png",
  "friedchicken3.png",
  "leaf.png",
  "menu.png",
  "noodles.png",
  "pork.png",
  "ramen.png",
  "ramen2.png",
  "ramen3.png",
  "ramen4.png",
  "ramen5.png",
  "ramen6.png",
  "ramen7.png",
  "rice.png",
  "roll.png",
  "roll2.png",
  "salad.png",
  "sandwich.png",
  "sandwich2.png",
  "shrimp.png",
  "shrimp2.png",
  "soups.png",
  "special.png",
  "starter.png",
  "sushi.png",
  "sushi2.png",
  "sushi3.png",
  "sushi4.png",
  "sushi5.png",
  "sushi6.png",
  "thai.png",
  "thai2.png",
]

export const fixZusatz = (value) =>
  (value || []).map((z) =>
    !Number.isNaN(z * 1) ? z * 1 : typeof z === "string" ? z.toUpperCase() : z
  )

export const fixTimes = (value) =>
  value
    ? mapValues(value, (list) =>
        list
          ? list.map((item) => ({
              start_time: item.start_time.toDate(),
              end_time: item.end_time.toDate(),
            }))
          : null
      )
    : null

export const convertTimesToFormValue = (value) =>
  mapValues(value, (list) =>
    list
      ? list.map((time) => [dayjs(time.start_time), dayjs(time.end_time)])
      : null
  )
